import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@ff-os/shared-react/components/icons/Icon';
import classNames from 'classnames';
import { AccessoriesOptionTab } from './accessories';
import { PriceLabelFrames } from './frames';
import { MagicOptionTab } from './MagicOptionTab';
import styles from './FotofunPanel.module.scss';

type OptionContentProps = {
    setPanelContentTab: (tab: 'main') => void;
};

const OptionContent = ({ setPanelContentTab }: OptionContentProps) => {

    const { t } = useTranslation();

    return (
        <div className={`${styles.optionContent}`}>
            <div className="p-2 lg:p-6">
                <div className={classNames(styles.tabContent, styles.tabContentMagic)}>
                    <p className={`${styles.title} justify-start gap-4`}>
                        <h4 className={styles.back} onClick={() => setPanelContentTab('main')}>
                            <Icon
                                type='general-ui-chevron-left'
                                className={styles.backButton}
                                strokeWidth={2}
                            />
                            {t('photo_prints.frames')}
                        </h4>
                        <PriceLabelFrames  />
                    </p>
                    <MagicOptionTab />
                </div>

                <div className={classNames(styles.tabContent, styles.tabContentAccessories)}>
                    <p className={styles.title}>
                        <h4 className={styles.back} onClick={() => setPanelContentTab('main')}>
                            <Icon
                                type='general-ui-chevron-left'
                                className={styles.backButton}
                                strokeWidth={2}
                            />
                            {t('photo_prints.accessories_title')}
                        </h4>
                    </p>
                    <p className={styles.subtitle}>{t('photo_prints.accessory_subtitle')}</p>
                    <AccessoriesOptionTab />
                </div>
            </div>
        </div>
    );
};

export { OptionContent };